import { styled } from '@mui/material';
import { Error, IApiCallStatus, ErrorIcon } from '../common';

export function StatusSaveRequst({
  apiCallStatus,
}: {
  apiCallStatus: IApiCallStatus;
}) {
  return (
    <Wrapper>
      {apiCallStatus === false && (
        <span tabIndex={0}>
          <ErrorIcon />
          <Error>Error occured when submitting request.</Error>
        </span>
      )}
    </Wrapper>
  );
}

const Wrapper = styled('article')(({ theme }) => ({
  '&>*+*': {
    marginLeft: '2rem',
  },
}));
